import React from "react";

// Components
import {FormPageLayout} from "../../components/layout/FormPageLayout";
import {PrivacyTermsFeature} from "../../features/privacyTerms";

const PrivacyTermsPage = () => (
  <FormPageLayout
    body={
      <PrivacyTermsFeature />
    }
  />
)

export default PrivacyTermsPage;